"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cogsToAgi = exports.agiToCogs = exports.agiInDecimal = exports.DECIMALS = void 0;
var _bignumber = _interopRequireDefault(require("bignumber.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const decimalsByNetwork = {
  FET: 18,
  AGIX: 8
};
const DECIMALS = exports.DECIMALS = decimalsByNetwork[process.env.REACT_APP_TOKEN_NAME];
const priceData = {
  fixed_price_model: "fixed_price",
  fixed_price_per_method: "fixed_price_per_method",
  precision: Math.pow(10, DECIMALS),
  divisibility: DECIMALS
};
const cogsToAgi = cogs => new _bignumber.default(cogs).div(new _bignumber.default(priceData.precision)).toFixed(priceData.divisibility);
exports.cogsToAgi = cogsToAgi;
const agiToCogs = agi => String(new _bignumber.default(agi).multipliedBy(new _bignumber.default(priceData.precision)));
exports.agiToCogs = agiToCogs;
const agiInDecimal = agi => parseFloat(agi).toFixed(priceData.divisibility);
exports.agiInDecimal = agiInDecimal;